// selective-preloading-strategy.service.ts

import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategyService implements PreloadingStrategy {

    private preloadOnDemandRoutes: string[] = [];
    private allowedDomain = "fams.ouk.ac.ke";

    preload(route: Route, load: () => Observable<any>): Observable<any> {

        const currentHost = window.location.hostname;

        // 🔥 Only allow preload if the app is running on fams.ouk.ac.ke
        if (currentHost !== this.allowedDomain) {
            // No preload on localhost or other domains
            return of(null);
        }

        // 🔥 Respect preload flag and list
        if (route.data?.['preload'] && this.preloadOnDemandRoutes.includes(route.path!)) {
            console.log(`Preloading module: ${route.path}`);

            return load().pipe(
                tap(() => console.log(`Module loaded: ${route.path}`))
            );
        }

        return of(null);
    }

    preloadRoute(path: string) {
        this.preloadOnDemandRoutes.push(path);
    }
}
